module.exports = __webpack_public_path__ + "static/media/img2-2.dbc2f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/biosense/biomasa/img2-2.png
// module id = 2285
// module chunks = 3